import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmartphotoListComponent } from './pages/smartphoto-list/smartphoto-list.component';
import { SmartphotoDetailComponent } from './pages/smartphoto-detail/smartphoto-detail.component';
import { SmartphotoCreateComponent } from './pages/smartphoto-create/smartphoto-create.component';
import { authGuard } from './guards/auth.guard';
import { I18NEXT_NAMESPACE_RESOLVER } from 'angular-i18next';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';

const routes: Routes = [
  {
    path: '',
    data: {
      i18nextNamespaces: ['brokers']
    },
    resolve: {
      i18next: I18NEXT_NAMESPACE_RESOLVER
    },
    children: [
      { path: '', component: TermsAndConditionsComponent, canActivate: [authGuard] },
      { path: 'terms-and-conditions', component: TermsAndConditionsComponent, canActivate: [authGuard] },
      { path: 'home', component: SmartphotoListComponent, canActivate: [authGuard] },
      { path: 'smartphoto/:id', component: SmartphotoDetailComponent, canActivate: [authGuard] },
      { path: 'create', component: SmartphotoCreateComponent, canActivate: [authGuard] },
      { path: '**', redirectTo: 'home' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
